module.exports = __webpack_public_path__ + "media/images/icon/icon_midnight-e55cf67af16af474f05c8cd1170d28b4.png";